import { useTranslation } from 'react-i18next';
import { ParkingType } from '../../../utils/utilTypes';

type Props = {
  parking: ParkingType;
};

export const ConsentRequiredPopup = ({ parking }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="absolute bg-white z-status-popup left-[36px] right-[36px] top-[32px] shadow-lg flex flex-col p-6">
      <div className="text-lg text-center text-primary font-bold">
        {t('consentRequiredPopup.title')}
      </div>
      <div className="my-4 text-sm text-center">
        {t('consentRequiredPopup.body', { name: parking.name })}
      </div>
    </div>
  );
};
